"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Tag_1 = require("./_Tag");
var _AnalyticsAndOperator_1 = require("./_AnalyticsAndOperator");
exports._AnalyticsFilter = {
    type: "structure",
    required: [],
    members: {
        Prefix: {
            shape: {
                type: "string"
            }
        },
        Tag: {
            shape: _Tag_1._Tag
        },
        And: {
            shape: _AnalyticsAndOperator_1._AnalyticsAndOperator
        }
    }
};
//# sourceMappingURL=_AnalyticsFilter.js.map